'use strict';

import trackingApi from './trackingApi';

const tracker = {};

function generateFeatureTrackingPayload(cinemaTrackingData, tilesTrackingData, status, scrolled = false) {
    let labels = enrichWithActivitySuffix(cinemaTrackingData.labels, status)
    if (status !== "clicked" && !scrolled) {
        labels["spx_Availability"] = [cinemaTrackingData.availability.toString()]
    }
    const cinemaTracking = {
        id: cinemaTrackingData.id,
        labels: labels,
        name: cinemaTrackingData.name,
        position: cinemaTrackingData.position,
        status: status
    }
    const tilesTracking = tilesTrackingData.map(tile => {
            return {
                id: tile.id,
                parentId: tile.parentId,
                variationId: tile.variationId,
                position: tile.position,
                name: "Spx-Product",
                status: status,
                labels: enrichWithActivitySuffix(tile.labels, status)
            }
        }
    );
    return [cinemaTracking].concat(tilesTracking);
}

function extractBaseLabelTrackingData(payload, status) {
    const result = {};
    if (status === "clicked") {
        result["wk.promo_AttributionFeature"] = ["SpaCinema_DetailView"]
        result["wk.promo_AttributionSource"] = [" "]
    }
    payload.map((entry) => entry.labels)
        .forEach((value) => {
            Object.entries(value).forEach(([key, innerValue]) => {
                if (key in result) {
                    result[key] = result[key].concat(innerValue)
                } else {
                    result[key] = innerValue;
                }
            })
        })
    return result;
}

function enrichWithActivitySuffix(labelsToEnrich, status) {
    const activitySuffix = status === "clicked" ? "Click" : "View"
    const labels = {}
    Object.entries(labelsToEnrich).forEach(([key, value]) => {
        if (key.startsWith("spx_")) {
            labels[key + activitySuffix] = value
        } else {
            labels[key] = value
        }
    })
    return labels
}

tracker.trackView = (cinemaView, tiles, eventMergeId) => {
    /*                                                                                                                 */
    /*                                                                            */
    const cinemaTrackingData = cinemaView.getTrackingData();
    const tilesTrackingData = tiles.map(tile => tile.getTrackingData());
    const featureTrackingPayload = generateFeatureTrackingPayload(cinemaTrackingData, tilesTrackingData, "loaded");
    const baseLabelTrackingData = extractBaseLabelTrackingData(featureTrackingPayload, "loaded");
    trackingApi.sendPageImpressionTrackingRequest(baseLabelTrackingData, eventMergeId);
    trackingApi.sendFeatureTrackingRequest(featureTrackingPayload);
}

tracker.trackClick = (cinemaView, tile) => {
    const cinemaTrackingData = cinemaView.getTrackingData();
    const tilesTrackingData = [tile].map(tile => tile.getTrackingData());
    const payload = generateFeatureTrackingPayload(cinemaTrackingData, tilesTrackingData, "clicked");
    const baseLabelPayload = extractBaseLabelTrackingData(payload, "clicked");
    const featurePayload = {name: 'click', features: payload};
    trackingApi.sendFeatureTrackingMoveAction(baseLabelPayload, featurePayload);
};

tracker.trackScrollPrevious = (cinemaView, tiles) => {
    tracker.trackScroll(cinemaView, tiles, 'previous');
}

tracker.trackScrollNext = (cinemaView, tiles) => {
    tracker.trackScroll(cinemaView, tiles, 'next');
}

tracker.trackScroll = (cinemaView, tiles, status) => {
    const cinemaTrackingData = cinemaView.getTrackingData();
    const tilesTrackingData = tiles.map(tile => tile.getTrackingData());
    const payload = generateFeatureTrackingPayload(cinemaTrackingData, tilesTrackingData, "loaded", true);
    const baseLabelPayload = extractBaseLabelTrackingData(payload, "loaded");
    const featuresPayload = {features: payload, name: status};
    trackingApi.sendFeatureTrackingScrollAction(baseLabelPayload, featuresPayload);
};

export default tracker;
